var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataIcon = function SvgDataIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M18.261 8.894a.37.37 0 0 0 .369-.368 7.37 7.37 0 0 0-7.37-7.37.37.37 0 0 0-.369.368v6.633a.737.737 0 0 0 .737.737zM18.63 10h-7.001a.52.52 0 0 0-.523.302.53.53 0 0 0 .154.589l4.952 4.945a.36.36 0 0 0 .4.083.4.4 0 0 0 .116-.083 7.67 7.67 0 0 0 2.27-5.469.367.367 0 0 0-.368-.368z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M9.116 18.842a7.6 7.6 0 0 0 5.402-2.27.367.367 0 0 0 0-.523l-4.945-4.952a.7.7 0 0 1-.155-.36v-7.01a.37.37 0 0 0-.368-.369 7.745 7.745 0 1 0 .066 15.476z"
  })));
};
export { SvgDataIcon as ReactComponent };